import React, { useState, useEffect } from 'react';

const DownloadService = () => {
    const [services, setServices] = useState([]);
    const [loading, setLoading] = useState(true);

    const excelDataMap = {
        "PS.ImmovableMonumentObjectP": { name: "უძრავი ძეგლი/ობიექტი", type: "წერტილოვანი" },
        "PS.ImmovableMonumentObjectA": { name: "უძრავი ძეგლი/ობიექტი", type: "პოლიგონალური" },
        "PS.PhysicalProtectionArea": { name: "ფიზიკური დაცვის არეალი", type: "პოლიგონალური" },
        "PS.VisualProtectionArea": { name: "ვიზუალური დაცვის არეალი", type: "პოლიგონალური" },
        "PS.GeneralProtectionZone": { name: "ზოგადი დამცავი ზონა", type: "პოლიგონალური" },
        "PS.MuseumMuseumReserve": { name: "მუზეუმ-ნაკრძალი/მუზეუმი", type: "წერტილოვანი" },
        "PS.UNESCOWorldHeritageBuffer": { name: "მსოფლიო მემკვიდრეობის ვიზუალური დაცვის არეალი (ბუფერული ზონა)", type: "პოლიგონალური" }
    };

    useEffect(() => {
        fetch('/api/downloads')
            .then(res => res.json())
            .then(data => {
                // ვიღებთ გასაღებების მასივს excelDataMap-იდან
                const order = Object.keys(excelDataMap);

                // ვასორტირებთ მიღებულ მონაცემებს ამ გასაღებების მიხედვით
                const sortedData = data.sort((a, b) => {
                    const nameA = a.name || a.Name;
                    const nameB = b.name || b.Name;

                    return order.indexOf(nameA) - order.indexOf(nameB);
                });

                setServices(sortedData);
                setLoading(false);
            });
    }, []);

    if (loading) return <div className="p-5 text-center">იტვირთება...</div>;

    return (
        <div className="container-fluid py-5 bg-light min-vh-100">
            {/* დამატებითი სტილები მობილური ვერსიისთვის */}
            <style>{`
                @media (max-width: 768px) {
                    .desktop-table { display: none; }
                    .mobile-cards { display: block; }
                }
                @media (min-width: 769px) {
                    .desktop-table { display: block; }
                    .mobile-cards { display: none; }
                }
                .mobile-card {
                    background: white;
                    border-radius: 15px;
                    padding: 20px;
                    margin-bottom: 20px;
                    box-shadow: 0 4px 6px rgba(0,0,0,0.05);
                }
            `}</style>

            <div className="container bg-white shadow-sm p-0 rounded-4 overflow-hidden">

                {/* Header Section */}
                <div className="p-4 p-md-5 border-bottom bg-white">
                    <h2 className="fw-bold text-dark mb-4 display-6" style={{ letterSpacing: '-1.5px' }}>
                        კულტურული მემკვიდრეობის სივრცითი მონაცემების ჩამოსატვირთი სერვისები
                    </h2>
                    <div className="p-3 p-md-4 rounded-4" style={{ backgroundColor: '#fcfcfc', border: '1px solid #f0f0f0' }}>
                        <p className="text-secondary fs-5 lh-lg mb-0" style={{ textAlign: 'justify' }}>
                            კულტურული მემკვიდრეობის სივრცითი მონაცემების სერვისების ჩამოსატვირთი ბმულები აერთიანებს მატერიალური კულტურული მემკვიდრეობის ძირითად კომპონენტებს: უძრავ ძეგლებსა და ობიექტებს, დამცავ ზონებს, მუზეუმებსა და მუზეუმ-ნაკრძალებს. თითოეული ბმულის საშუალებით შესაძლებელია შესაბამისი სივრცითი მონაცემების ჩამოტვირთვა.
                            <br></br>
                            <br></br>
                            გთხოვთ გაითვალისწინოთ: უძრავი ძეგლებისა და ობიექტების ჩამოსატვირთ ფაილებში ველი „ადგილმდებარეობის სიზუსტე“ (Accuracy) ასახავს ობიექტის მდებარეობის განსაზღვრის სიზუსტეს. იმ შემთხვევაში, თუ აღნიშნულ ველში მითითებულია მნიშვნელობა „დასაზუსტებელია“, ობიექტის მდებარეობა განსაზღვრულია მიახლოებით და საჭიროებს დამატებით დაზუსტებას. შესაბამისად, ასეთ ობიექტებთან დაკავშირებული ფიზიკური და ვიზუალური დაცვის არეალებიც საჭიროებს დაზუსტებას.
                        </p>
                    </div>
                </div>

                {/* DESKTOP TABLE VIEW */}
                <div className="desktop-table p-4">
                    <div className="table-responsive">
                        <table className="table table-hover align-middle mb-0">
                            <thead>
                                <tr className="text-muted small text-uppercase">
                                    <th className="border-0 pb-4 ps-4">#</th>
                                    <th className="border-0 pb-4">მონაცემის დასახელება</th>
                                    <th className="border-0 pb-4 text-center">ტიპი</th>
                                    <th className="border-0 pb-4 text-center">თარიღი</th>
                                    <th className="border-0 pb-4 text-center">SHAPEFILE</th>
                                    <th className="border-0 pb-4 text-center">GEOJSON</th>
                                    <th className="border-0 pb-4 text-center">GEODATABASE</th>
                                </tr>
                            </thead>
                            <tbody>
                                {services.map((service, index) => {
                                    const folderId = service.name || service.Name;
                                    const mappedInfo = excelDataMap[folderId] || { name: folderId, type: "---" };
                                    return (
                                        <tr key={index} className="border-bottom">
                                            <td className="ps-4 text-muted">{index + 1}</td>
                                            <td>
                                                <div className="fw-bold text-dark">{mappedInfo.name}</div>
                                            </td>
                                            <td className="text-center">
                                                <Badge text={mappedInfo.type} color="#f1f4f8" />
                                            </td>
                                            <td className="text-center">
                                                <Badge text={service.date || '2026-02-11'} color="#ffffff" border />
                                            </td>
                                            <td className="text-center"><DownloadButton url={service.shapefileUrl} /></td>
                                            <td className="text-center"><DownloadButton url={service.geoJsonUrl} /></td>
                                            <td className="text-center"><DownloadButton url={service.gdbUrl} /></td>
                                        </tr>
                                    );
                                })}
                            </tbody>
                        </table>
                    </div>
                </div>

                {/* MOBILE CARD VIEW (As per image_9ccd97.jpg) */}
                <div className="mobile-cards p-3 bg-light">
                    {services.map((service, index) => {
                        const folderId = service.name || service.Name;
                        const mappedInfo = excelDataMap[folderId] || { name: folderId, type: "---" };

                        return (
                            <div key={index} className="mobile-card">
                                <div className="d-flex justify-content-between align-items-start mb-3">
                                    <div>
                                        <span className="text-muted fw-bold me-2">#{index + 1}</span>
                                        <h5 className="fw-bold d-inline-block mb-1">{mappedInfo.name}</h5>
                                    </div>
                                </div>

                                <div className="mb-3">
                                    <div className="d-flex justify-content-between small border-bottom py-2">
                                        <span className="text-muted">ტიპი:</span>
                                        <span className="fw-bold text-dark">{mappedInfo.type}</span>
                                    </div>
                                    <div className="d-flex justify-content-between small py-2">
                                        <span className="text-muted">თარიღი:</span>
                                        <span className="fw-bold text-dark">{service.date || '2026-02-11'}</span>
                                    </div>
                                </div>

                                <div className="d-grid gap-2 mt-3">
                                    <MobileDownloadButton label="Shapefile — ჩამოტვირთვა" url={service.shapefileUrl} />
                                    <MobileDownloadButton label="geoJSON — ჩამოტვირთვა" url={service.geoJsonUrl} />
                                    <MobileDownloadButton label="Geodatabase — ჩამოტვირთვა" url={service.gdbUrl} />
                                </div>
                            </div>
                        );
                    })}
                </div>
            </div>
        </div>
    );
};

// დამხმარე კომპონენტები
const Badge = ({ text, color, border }) => (
    <div style={{
        backgroundColor: color,
        color: '#4a5568',
        borderRadius: '5px',
        fontSize: '14px',
        minWidth: '130px',
        padding: '10px',
        display: 'inline-block',
        border: border ? '1px solid #eee' : 'none',
        fontWeight: '500'
    }}>{text}</div>
);

const DownloadButton = ({ url }) => (
    <a href={url || '#'} style={{
        backgroundColor: url ? '#E57959' : '#f8fafc',
        color: url ? '#ffffff' : '#ccc',
        borderRadius: '5px',
        fontSize: '14px',
        minWidth: '150px',
        padding: '12px 20px',
        display: 'inline-block',
        textDecoration: 'none',
        fontWeight: '500',
        pointerEvents: url ? 'auto' : 'none',
        border: url ? 'none' : '1px solid #eee'
    }}>
        {url ? 'ჩამოტვირთვა' : '---'}
    </a>
);

const MobileDownloadButton = ({ label, url }) => (
    <a href={url || '#'} className="btn w-100 py-3 text-start px-3 d-flex justify-content-between align-items-center"
        style={{
            backgroundColor: url ? '#E57959' : '#f8fafc',
            color: url ? '#ffffff' : '#adb5bd',
            borderRadius: '10px',
            fontSize: '14px',
            fontWeight: '500',
            textDecoration: 'none',
            pointerEvents: url ? 'auto' : 'none',
            border: 'none',
            marginTop: '5px'
        }}>
        {label}
    </a>
);

export default DownloadService;